import React from 'react';
import './Policy.css';

export default function PrivacyPolicy() {
  return (
    <div className="policy-page container">
      <h1>Privacy Policy</h1>
      <div className="policy-content">
        <p>Last updated: May 06, 2026</p>
        <p>At KOA, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information.</p>
        <section>
          <h2>1. Information We Collect</h2>
          <p>We collect information you provide directly to us, such as when you create an account, make a purchase, or sign up for our newsletter. This may include your name, email address, phone number, and shipping address.</p>
        </section>
        <section>
          <h2>2. How We Use Your Information</h2>
          <p>We use your information to process orders, communicate with you about your account, and send you marketing communications (if you've opted in). We do NOT sell your data to third parties.</p>
        </section>
        <section>
          <h2>3. Cookies</h2>
          <p>We use cookies to enhance your browsing experience and analyze website traffic. You can choose to disable cookies in your browser settings.</p>
        </section>
      </div>
    </div>
  );
}
